module.exports = __webpack_public_path__ + "11ce86751a2a1cdfde6e87cc921d47a5.svg";